export default __webpack_public_path__ + "static/media/banner_img_2.cdafa216.png";